
import { Group } from "./group.component.js";

class UrlMedia extends Group {
  namespace = "visual:urlMedia";
}

const urlMedia = new UrlMedia();
export { UrlMedia, urlMedia };
